import { useEffect, useRef, useState } from "react";
import { Box, Button } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import useBoardViewport from "../hooks/useBoardViewport";

export default function BoardViewport({ children, gap = 2 }) {
  const { boardRef, boardHeight } = useBoardViewport();
  const [expanded, setExpanded] = useState(false);
  const toggleRef = useRef(null);
  useEffect(() => {
    if (!expanded) return;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = overflow; };
  }, [expanded]);
  const restore = () => { setExpanded(false); toggleRef.current?.focus(); };
  return <Box
    onKeyDown={event => { if (expanded && event.key === "Escape" && !event.defaultPrevented) { event.stopPropagation(); restore(); } }}
    sx={expanded ? { position: "fixed", inset: 0, zIndex: theme => theme.zIndex.drawer + 1, bgcolor: "background.default", p: 1.5, display: "flex", flexDirection: "column", overflow: "hidden" } : {}}
  >
    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 0.5, flexShrink: 0 }}>
      <Button ref={toggleRef} size="small" aria-pressed={expanded} startIcon={expanded ? <FullscreenExitIcon /> : <FullscreenIcon />} onClick={() => expanded ? restore() : setExpanded(true)} sx={{ fontSize: 12, py: 0.25 }}>
        {expanded ? "Restaurar vista" : "Ampliar tablero"}
      </Button>
    </Box>
    <Box ref={boardRef} data-crm-board sx={{ display: "flex", gap, height: expanded ? "auto" : boardHeight, flex: expanded ? 1 : undefined, minHeight: 0, overflowX: "auto", overflowY: "hidden", pb: 2, boxSizing: "border-box" }}>
      {children}
    </Box>
  </Box>;
}
